import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import FileUploadBox from "@/shared/components/common/uploadFile";
import { useState } from "react";
/**
 * AddGroupUser
 *
 * کامپوننت برای افزودن گروهی کاربران از طریق فایل اکسل.
 * این بخش مخصوص کاربرانی است که از قبل در سامانه پولی پی  ثبت‌نام شده‌اند.
 *
 * ویژگی‌ها:
 * - نمایش متن راهنما با شماره کارت به صورت فارسی
 * - امکان بارگذاری فایل اکسل با کشیدن و رها کردن یا انتخاب از طریق دکمه
 * - واکنش‌گرا: 
 *   - Stack و FileUploadBox در موبایل به صورت ستونی نمایش داده می‌شوند
 *   - فضای مناسب بین المان‌ها برای موبایل
 *
 * @param selectedOption حالت انتخاب‌شده (اختیاری، برای والد کنترل می‌شود)
 * @param setSelectedOption تابع برای تغییر حالت انتخاب‌شده
 *
 * @returns JSX.Element
 */
export const AddGroupUser = ({selectedOption,setSelectedOption,}: {selectedOption: any;setSelectedOption: any;}) => {
  const [fileExel, setFileExel] = useState<File | null>(null);

  const handleFile = (file: File) => {
    setFileExel(file);
  };

  return (
    <StackKit gap={4} sx={{ width: "100%" }}>
      {/* Instruction Text */}
      <TypoGraphyKit variant="body1">
        پذیرنده گرامی؛ این بخش مخصوص کاربرانی میباشد که از قبل در سامانه{" "}
        پولی پی ثبت نام شده‌اند. لطفا برای افزودن کاربر به
        این سازمان؛ شماره تماس و کد ملی کاربر را وارد نمایید.
      </TypoGraphyKit>

      {/* File Upload Section */}
      <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={2} sx={{ width: "100%" }}>
        <FileUploadBox onFileSelect={handleFile} fileExel={fileExel} setFileExel={setFileExel}/>
      </StackKit>
    </StackKit>
  );
};

export default AddGroupUser;
